import { Photo } from "traveldesk-ui"

export default class ItineraryStopPhotoModel {
    itineraryStopGuid: string = ''
    photoId: number = 0
    photo: Photo = new Photo()
}
